module.exports = __webpack_public_path__ + "img/m-filter-2.e8a03e7a.svg";